var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSample({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.52563 6.07248C5.6635 6.50862 4.27777 8.1673 4.27777 10.1469C4.27777 12.459 6.16812 14.3333 8.49999 14.3333C10.8319 14.3333 12.7222 12.459 12.7222 10.1469C12.7222 8.1673 11.3365 6.50862 9.47435 6.07248V7.18672C10.7313 7.59321 11.6396 8.76488 11.6396 10.1469C11.6396 11.8662 10.2339 13.2599 8.49999 13.2599C6.76604 13.2599 5.36039 11.8662 5.36039 10.1469C5.36039 8.76488 6.26867 7.59321 7.52563 7.18672V6.07248Z",
    fill: "#1C3863"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.79344 1.66667H11.2065V2.74012H5.79344V1.66667Z",
    fill: "#1C3863"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.44301 2.52543H7.52563V7.0339H6.44301V2.52543Z",
    fill: "#1C3863"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.47435 2.52543H10.557V7.0339H9.47435V2.52543Z",
    fill: "#1C3863"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7089 9.18223H5.12222V8.16889H11.7089V9.18223Z",
    fill: "#1C3863"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.7303 3.82927V3.21139H9.49797V3.82927H8.7303ZM9.49797 4.87053H8.94354V4.25264H9.49797V4.87053ZM9.49797 5.21952V5.8374H8.7303V5.21952H9.49797Z",
    fill: "#1C3863"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSample);
export default __webpack_public_path__ + "static/media/sample.3e78bf20020bf0f2a7e76c96ca0dd5ec.svg";
export { ForwardRef as ReactComponent };